/* eslint-disable react/prop-types */
import React from 'react';
import Select from 'react-select';
// helpers
import { selectStyles } from '../../helpers';

const SelectReact = ({
  name,
  error,
  label,
  value,
  isMulti,
  options,
  touched,
  required,
  className,
  handleBlur,
  isClearable,
  placeholder,
  handleChange,
  isSearchable,
  noOptionsMessage,
}) => (
  <>
    <div className={`form-outline mb-4 DashBoardInputBx${className ? ` ${className}` : ''}`}>
      <label id={name} className='form-label' htmlFor={name}>
        {label}
        {required && <span className='RedStar'>*</span>}
      </label>
      <Select
        name={name}
        value={value}
        isMulti={isMulti}
        options={options}
        onBlur={handleBlur}
        styles={selectStyles}
        onChange={handleChange}
        isClearable={isClearable}
        placeholder={placeholder}
        isSearchable={isSearchable}
        noOptionsMessage={noOptionsMessage}
        className={`${touched && error && 'input-error-react-select'}`}
      />
      {
        touched && error && (
          <div className='text-danger'>{error}</div>
        )
      }
    </div>
  </>
);

export default SelectReact;
